var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.49227 0.386083C5.65208 -0.128695 6.34791 -0.128694 6.50773 0.386084L7.55815 3.7697C7.62962 3.99991 7.8346 4.15578 8.06588 4.15578H11.4651C11.9823 4.15578 12.1973 4.84841 11.7789 5.16656L9.02887 7.25775C8.84176 7.40003 8.76346 7.65223 8.83493 7.88245L9.88536 11.2661C10.0452 11.7808 9.48223 12.2089 9.06384 11.8908L6.31379 9.79957C6.12668 9.65729 5.87332 9.65729 5.68621 9.79957L2.93616 11.8908C2.51777 12.2089 1.95483 11.7808 2.11464 11.2661L3.16507 7.88245C3.23654 7.65223 3.15824 7.40003 2.97113 7.25775L0.221086 5.16656C-0.197303 4.84841 0.0177208 4.15578 0.534878 4.15578H3.93412C4.1654 4.15578 4.37038 3.99991 4.44185 3.7697L5.49227 0.386083Z",
    fill: "#FFFF00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.ec4a2742c9a28c2bd16b7d5047df1caa.svg";
export { ForwardRef as ReactComponent };